export const housekeepingDrawer = {
  close: "Zamknij",
  guest: "Gość",

  cleaning: {
    title: "Status sprzątania",
    lastCleaned: "Posprzątano {date}",
    evidenceAlt: "dowód",
  },

  status: {
    dirty: "Do sprzątania",
    in_progress: "W trakcie",
    clean: "Posprzątane",
    inspected: "Sprawdzone",
    out_of_service: "Wyłączone z użytku",
  },

  occupancy: {
    title: "Obłożenie",
    aboutToLeave: "Wkrótce wyjazd",
    checkIn: "Check-in {date}",
    checkOut: "Check-out {date}",
    checkoutTime: "Check-out {time}",
    booking: "Rezerwacja {code}",
    nextArrivalToday: "Następny przyjazd dzisiaj",
    fromTime: "od {time}",
    labels: {
      vacant: "Wolne",
      occupied: "Zajęte",
      departure_today: "Wyjazd dzisiaj",
      arrival_today: "Przyjazd dzisiaj",
      turnover: "Wyjazd i przyjazd dzisiaj",
    },
  },

  window: {
    windowLabel: "Okno",
    standardSchedule: "Standardowy harmonogram",
    sub: "{label}: check-out {checkout} → check-in {checkin}",
    overdue: "Przyjazd po terminie · to sprzątanie ma priorytet",
    untilArrival: "{dur} do przyjazdu",
  },

  tasks: {
    title: "Zadania sprzątania",
    // Liczba mnoga (vue-i18n v8, pipes) — choiceIndex = liczba otwartych zadań
    pendingCount: "{count} oczekujące | {count} oczekujące | {count} oczekujących",
    newPlaceholder: "Dodaj zadanie (np. Wymiana ręczników)",
    priorityTitle: "Priorytet",
    dateTitle: "Data",
    timeTitle: "Godzina (opcjonalnie)",
    assignTitle: "Przypisz do",
    assignAllOption: "Wszyscy (sprzątanie i konserwacja)",
    byRole: "Według roli",
    wholeRoleSuffix: "(cała rola)",
    people: "Osoby",
    add: "Dodaj",
    adding: "Dodawanie…",
    loading: "Wczytywanie zadań…",
    empty: "Brak zadań. Dodaj pierwsze powyżej.",
    markPending: "Oznacz jako oczekujące",
    markDone: "Oznacz jako wykonane",
    priorityDotTitle: "Priorytet: {priority}",
    delete: "Usuń",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Niski",
    normal: "Normalny",
    high: "Wysoki",
    urgent: "Pilny",
  },

  roles: {
    limpieza: "Sprzątanie",
    mantenimiento: "Konserwacja",
    propietario: "Właściciel",
  },

  assignee: {
    assigned: "Przypisane",
    all: "Wszyscy",
  },
};
